import { render, staticRenderFns } from "./LoaderTableSkeleton.vue?vue&type=template&id=6e7616c2"
import script from "./LoaderTableSkeleton.vue?vue&type=script&lang=js"
export * from "./LoaderTableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LoaderTableSkeleton.vue?vue&type=style&index=0&id=6e7616c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports